import bus from '@/state/modules/bus'
import tag from '@/state/modules/tag'
import map from '@/state/modules/map'
import socket from '@/state/modules/socket'

export default {
  bus,
  tag,
  map,
  socket
}
